import React from "react";
import {FEATS} from "../../data/siteData";
import {GRAD, inkOn, stagger} from "../../utils";
import Icon from "../common/Icon";

const FeatureStrip = () => (
    <section className="pb-container" style={{padding: '0 24px'}}>
        <div className="pb-feats">
            {FEATS.map((f, i) => (
                <div key={f.title} className="pb-reveal pb-feat hover-bg-soft" style={{animationDelay: stagger(i)}}>
                    <span className="pb-feat-icon" style={{background: GRAD[f.color], color: inkOn(f.color)}}>
                        <Icon name={f.icon} size={23}/>
                    </span>
                    <div>
                        <p className="pb-feat-title">{f.title}</p>
                        <p className="pb-feat-sub">{f.sub}</p>
                    </div>
                </div>
            ))}
        </div>
    </section>
);

export default FeatureStrip;
